export enum ValidationErrorTypes {
  VALUE_DOES_NOT_PROVIDED = "VALUE_DOES_NOT_PROVIDED",
  IS_NOT_VAT_MEMBER = "IS_NOT_VAT_MEMBER",
  INVALID_PHONE_NUMBER = "INVALID_PHONE_NUMBER",
  INVALID_ADDRESS = "INVALID_ADDRESS",
  INVALID_EMAIL = "INVALID_EMAIL",
}

export class ValidationError extends Error {
  constructor(public message: string, public type: ValidationErrorTypes) {
    super()

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError)
    }
  }
}
